import classes from "./image-styles.module.css";
import img1 from "../assets/1.png";
import img2 from "../assets/2.png";
import img3 from "../assets/3.png";

import { useEffect, useState } from "react";

let imgArr = [img1, img2, img3];
const Image = (props) => {
  const [clickedNext, setClickedNext] = useState(false);

  const [currentImg, setCurrentImg] = useState(
    clickedNext ? props.nextPicture : props.image
  );
  const [bg, setBg] = useState(imgArr[currentImg - 1]);
  // let bg = imgArr[currentImg - 1]
  let nextStyle = props.nextButtonStyle;
  useEffect(() => {
    console.log(props);
    console.log(props);
    setCurrentImg(clickedNext ? props.nextPicture : props.image);
    let temp = imgArr[currentImg - 1];
    setBg(temp);
  }, [bg, currentImg, props.image, clickedNext]);
  return (
    <div
      className={classes.image}
      style={{
        display: props.display ? "flex" : "none",
        backgroundImage: "url(" + bg + ")",
        boxShadow: "2px 2px 40px",
      }}
    >
      {!clickedNext && props.nextPicture && (
        <div
          style={{
            position: "absolute",
            bottom: "5vw",
            fontSize: "1.5vw",
            right: "6vw",
            width: "6vw",
            height: "3vw",
            backgroundColor: "#98024d59",
            borderRadius: "10vw",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
          }}
          onClick={() => {
            setClickedNext(true);
          }}
        >
          Next
        </div>
      )}

      <div
        onClick={() => {
          props.onClose();
          setClickedNext(false);
        }}
        className={classes.close}
      >
        X
      </div>
    </div>
  );
};
export default Image;
